
export class RulePredicatesHumanExpression {
  conditions: { [key: string]: string };
  exceptions: { [key: string]: string };
}
